import { render, staticRenderFns } from "./MonitoringPlans.vue?vue&type=template&id=c3c2e006&"
import script from "./MonitoringPlans.vue?vue&type=script&lang=js&"
export * from "./MonitoringPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports